<template>
  <span class="svg-icon-alert">
    <svg xmlns="http://www.w3.org/2000/svg" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.83378 3.44147L1.40707 17.5092C0.868672 18.4413 0.865506 19.5721 1.39067 20.4935C1.91583 21.4148 2.89044 21.9883 3.95088 21.9999L20.8152 22C21.8866 21.9883 22.8612 21.4148 23.3864 20.4935C23.9115 19.5721 23.9084 18.4413 23.3781 17.5229L14.9433 3.44147C14.3993 2.54474 13.4318 2 12.3885 2C11.3453 2 10.3777 2.54474 9.83663 3.43673L9.83378 3.44147ZM11.3936 9.06642V13.046C11.3936 13.5954 11.839 14.0409 12.3884 14.0409C12.9379 14.0409 13.3833 13.5954 13.3833 13.046V9.06642C13.3833 8.51696 12.9379 8.07153 12.3884 8.07153C11.839 8.07153 11.3936 8.51696 11.3936 9.06642ZM13.0919 17.729C13.4805 17.3405 13.4805 16.7106 13.0919 16.322C12.7034 15.9335 12.0735 15.9335 11.685 16.322C11.2964 16.7106 11.2964 17.3405 11.685 17.729C12.0735 18.1175 12.7034 18.1175 13.0919 17.729Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
